import {
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerCloseButton,
    FormLabel
} from "@chakra-ui/react"
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
// import './Panel.css'
import ProgressBar from "../../../utils/progressBar/ProgressBar";
import {addPanelAction,updatePanelAction} from '../../../redux/reduxSlice/PanelSlice.js'
import {addPanel,updatePanel} from '../../../redux/api/panelApi/panelApi.js';
import {useDispatch, useSelector} from 'react-redux';

export function PanelForm(props) {

    const { dataToEdit, setIsUpdateMode, isUpdateMode, panelId } = props;
    const [showProgressBar, setShowProgressBar] = useState(false);
    const closeDrawer = props.closePanel;
    const dispatch = useDispatch();
    const initialFormData = {
        panelName: "",
        panelDescription: "",
        mobile: null
    }
    const [formData, setFormData] = useState(initialFormData);

    // UpdateMode Use-effect
    useEffect(() => {
        if (isUpdateMode && dataToEdit) {
            setFormData((prev) => ({
                ...prev, ...props.dataToEdit,
            }))
        }
    }, [isUpdateMode, dataToEdit]);

    const handleOnClose = () => {
        closeDrawer()
        setFormData(initialFormData);
        setIsUpdateMode(false); // Reset update mode when closing
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("submit", formData)
        setShowProgressBar(true)

        addPanel({...formData, createdBy: localStorage.getItem("email")}).then((response) => {
            console.log("response", response)
            if (response.data.success) {
                console.log("hyyy", response.data.resp.ROWID)
                const ROWID = response.data.resp.ROWID
                dispatch(addPanelAction({ROWID, formData} ));
                toast.success("Panel created successfully")
                closeDrawer()
                handleOnClose()
                setFormData(initialFormData);
            } else {
                toast.error("Panel creation failed")
            }
        }).catch((error) => {
            console.log("error", error)
            toast.error("Panel creation failed")
        }).finally(() => {
            setShowProgressBar(false); // Hide loader in all cases
        })
    }
    

    const handleUpdate = (e) => {
        e.preventDefault();
        console.log("update", formData)
        setShowProgressBar(true)
        
        // Call update API
        updatePanel({...formData, updatedBy: localStorage.getItem("email")}).then((response) => {
            console.log("update response", response)
            if (response.data.success) {
                // Dispatch update action with the updated data
                dispatch(updatePanelAction({
                    ...formData,
                    ROWID: dataToEdit.ROWID // Use the ROWID from dataToEdit
                }));
                toast.success("Panel updated successfully")
                closeDrawer()
                handleOnClose()
                setFormData(initialFormData);
                setIsUpdateMode(false); // Reset update mode
            } else {
                toast.error("Panel update failed")
            }
        }).catch((error) => {
            console.log("error", error)
            toast.error("Panel update failed")
        }).finally(() => {
            setShowProgressBar(false); // Hide loader in all cases
        })
    }

    return (
        <>

            <Drawer isOpen={props.isPanel} size='xl' onClose={handleOnClose}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>{isUpdateMode ? "Update Panel" : "Create Panel"}</DrawerHeader>
                    <DrawerBody>
                        {showProgressBar && <ProgressBar colorScheme='pink' />}
                        <form onSubmit={isUpdateMode ? handleUpdate : handleSubmit}>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row '>
                                        <legend style={{ fontSize: 'Large' }} className='sub-headers'>Panel Information</legend>
                                        <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                                            <div className='search-by-title'>
                                                <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Panel Name' name='panelName' value={formData?.panelName} onChange={handleChange} />
                                            </div>
                                            <FormLabel className="small-label ps-3">Panel Name<span style={{ color: 'red' }}>*</span></FormLabel>
                                        </div>
                                        <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                                            <div className='search-by-title'>
                                                <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Panel Description' name='panelDescription' value={formData?.panelDescription} onChange={handleChange} />
                                            </div>
                                            <FormLabel className="small-label ps-3">Panel Description</FormLabel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </DrawerBody>
                    <center><DrawerFooter style={{ display: 'inline-block' }} >
                        <div className='gap-3 d-flex'>
                            <button variant='outline' mr={3} onClick={handleOnClose} className="cancel-button">
                                Cancel
                            </button>
                            <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handleUpdate(e) }} disabled={showProgressBar}>
                                {isUpdateMode ? "Update" : "Submit"}
                            </button>
                        </div>
                    </DrawerFooter></center>
                </DrawerContent>
            </Drawer>
        </>
    )
}